export default {
  computed: {
    steps() {
      const steps = [];

      if (!this.hideSelection && !this.flags.orderSelectionSkipped && !this.isOptin) steps.push({ name: 'substore.progress_selection' });

      if (!(this.flags.isOnlyReservationAllowed || this.flags.isPurchaseRedirectRequired)) {
        if (this.flags.thirdPartyAuthentication && !this.isOptin) {
          steps.push({ name: 'substore.progress_account' });
        }
        steps.push({ name: `substore.${this.isOptin ? 'optin_' : ''}progress_summary` });
      }

      steps.push({ name: `substore.${this.isOptin ? 'optin_' : ''}progress_confirmation` });

      return steps;
    },
  },
};
